import { Component, Input } from '@angular/core';
import { OrderDetailModel } from "@cv-invision/cv.invision-intelligence.ux";
import { TelemetryEventService } from "@cv-invision/core";
import { OverviewSubHeaderService } from "../service/overview-sub-header.service";

@Component({
	selector: 'cv-order-info',
	templateUrl: './order-info.component.html',
	styleUrls: [ './order-info.component.scss' ],
})
export class OrderInfoComponent {
	@Input() orderInboxModel: OrderDetailModel;

	constructor(
		private telemetryEventService:  TelemetryEventService,
		private overViewSubheaderService: OverviewSubHeaderService) {
	}

	/**
	 * return to the main intelligence module but sending the telemetry event
	 */
	returnBackClicked(): void {
		this.telemetryEventService.setEvent('review-stop', 'User.GoBackInbox');
		this.overViewSubheaderService.subheaderEvents.next(
			{
				name: 'RETURN_HOME',
				event: null
			}
		);
	}
}
